module.exports = __webpack_public_path__ + "9a50e0f09d19f66d2c8d56a5e9d5472c.svg";